// GENERATED by scripts/sync-workflox.js — do not edit by hand.
// Re-run `npm run sync:workflox` after publishing on workflox.net.
import img0 from "../assets/workflox/blog/agentic-ai-companies-how-to-evaluate-one.svg";
import img1 from "../assets/workflox/blog/enterprise-knowledge-base-for-ai-agents-a-methodology.svg";
import img2 from "../assets/workflox/blog/ai-agent-tooling-standards-mcp-function-calling.svg";
import img3 from "../assets/workflox/blog/custom-ai-development-what-it-includes-and-what-it-costs.svg";
import img4 from "../assets/workflox/blog/how-to-choose-a-data-engineering-company.svg";
import img5 from "../assets/workflox/blog/databricks-strengths-weaknesses-and-when-not-to-use-it.svg";
import img6 from "../assets/workflox/projects/moment-up-app.webp";
import img7 from "../assets/workflox/projects/vidunderlig-app.webp";
import img8 from "../assets/workflox/projects/pick-tup-app.webp";
import img9 from "../assets/workflox/projects/cabz-web.webp";
import img10 from "../assets/workflox/projects/chain-of-ko-mmand-web.webp";
import img11 from "../assets/workflox/projects/oasis-web.webp";
import img12 from "../assets/workflox/projects/wave-makers-app.webp";
import img13 from "../assets/workflox/projects/cabz-app-app.webp";
import img14 from "../assets/workflox/projects/chain-of-ko-mmand-app.webp";
import img15 from "../assets/workflox/projects/ace-web.webp";
import img16 from "../assets/workflox/projects/gradia-web.webp";
import img17 from "../assets/workflox/projects/n8n-workflow-automation-ai.webp";
import img18 from "../assets/workflox/projects/sneaker-authentication-ai-ui.webp";
import img19 from "../assets/workflox/projects/fitbizz-fitness-platform-ai-ui.webp";
import img20 from "../assets/workflox/projects/asemani-smart-operations-ui.webp";
import img21 from "../assets/workflox/projects/mabwas-property-ai-agent-ui.webp";
import img22 from "../assets/workflox/projects/shpd-ai-supply-chain-ui.webp";

export const WORKFLOX = "https://www.workflox.net";

export const workfloxPosts = [
  {
    "slug": "agentic-ai-companies-how-to-evaluate-one",
    "title": "Agentic AI Companies: How to Evaluate One Before You Sign",
    "category": "AI Technology",
    "date": "2026-09-22",
    "excerpt": "How to evaluate agentic AI companies before you sign: nine questions on evaluation sets, tool permissions, human boundaries and observability.",
    "url": "https://www.workflox.net/blog/agentic-ai-companies-how-to-evaluate-one",
    "image": img0
  },
  {
    "slug": "enterprise-knowledge-base-for-ai-agents-a-methodology",
    "title": "Building an Enterprise Knowledge Base for AI Agents: A Methodology That Survives Production",
    "category": "AI Technology",
    "date": "2026-09-18",
    "excerpt": "A seven-step methodology for an enterprise knowledge base AI agents can rely on: inventory, chunking, retrieval evaluation, access control and sync.",
    "url": "https://www.workflox.net/blog/enterprise-knowledge-base-for-ai-agents-a-methodology",
    "image": img1
  },
  {
    "slug": "ai-agent-tooling-standards-mcp-function-calling",
    "title": "AI Agent Tooling Standards: MCP, Function Calling, and What “Tool Use” Actually Requires",
    "category": "AI Technology",
    "date": "2026-09-11",
    "excerpt": "AI agent tooling standards in 2026: function calling, the Model Context Protocol, and the permissions, idempotency and logging an agent needs first.",
    "url": "https://www.workflox.net/blog/ai-agent-tooling-standards-mcp-function-calling",
    "image": img2
  },
  {
    "slug": "custom-ai-development-what-it-includes-and-what-it-costs",
    "title": "Custom AI Development: What It Includes, What It Costs, and When Off-the-Shelf Is Better",
    "category": "AI Technology",
    "date": "2026-09-08",
    "excerpt": "What custom AI development includes, what each part costs in 2026, and the cases where an off-the-shelf product beats a custom build.",
    "url": "https://www.workflox.net/blog/custom-ai-development-what-it-includes-and-what-it-costs",
    "image": img3
  },
  {
    "slug": "how-to-choose-a-data-engineering-company",
    "title": "How to Choose a Data Engineering Company: What to Check Before the Pipeline Gets Built",
    "category": "Data & Analytics",
    "date": "2026-09-04",
    "excerpt": "How to choose a data engineering company: the questions on failure handling, data quality, tooling and ownership that separate a partner from a contractor.",
    "url": "https://www.workflox.net/blog/how-to-choose-a-data-engineering-company",
    "image": img4
  },
  {
    "slug": "databricks-strengths-weaknesses-and-when-not-to-use-it",
    "title": "Databricks: Strengths, Weaknesses, and When Not to Use It",
    "category": "Data & Analytics",
    "date": "2026-08-28",
    "excerpt": "An honest Databricks assessment for 2026: where the lakehouse wins, where it costs too much, and when Snowflake, BigQuery or Postgres is the better answer.",
    "url": "https://www.workflox.net/blog/databricks-strengths-weaknesses-and-when-not-to-use-it",
    "image": img5
  }
];

export const workfloxProjects = [
  {
    "name": "Moment Up",
    "kind": "Mobile App",
    "summary": "Nightlife social platform with location based discovery, party style short videos, events and promotions.",
    "stack": [
      "React Native",
      "React",
      "Node.js",
      "MongoDB",
      "Firebase"
    ],
    "url": "https://apps.apple.com/us/app/moment-up/id6748009014",
    "caseStudy": "https://www.workflox.net/case-studies/moment-up",
    "image": img6
  },
  {
    "name": "Vidunderlig",
    "kind": "Mobile App",
    "summary": "Baby mental development tracker with expert backed guidance, leap notifications, and progress logs.",
    "stack": [
      "React Native",
      "Node.js",
      "MongoDB"
    ],
    "url": "https://apps.apple.com/us/app/vidunderlig/id6453559072",
    "caseStudy": "https://www.workflox.net/case-studies/vidunderlig",
    "image": img7
  },
  {
    "name": "Pick’tUp",
    "kind": "Mobile App",
    "summary": "Courier and parcel delivery platform with real time tracking, secure payments, and feedback flow.",
    "stack": [
      "React Native",
      "Node.js",
      "MongoDB",
      "Payments"
    ],
    "url": "https://apps.apple.com/us/app/picktup/id6478540852",
    "caseStudy": "https://www.workflox.net/case-studies/picktup",
    "image": img8
  },
  {
    "name": "Cabz",
    "kind": "Web App",
    "summary": "Island taxi booking experience, optimized for transfers, airports, ferries, and local rides.",
    "stack": [
      "React",
      "Node.js"
    ],
    "url": "https://cabz.app/",
    "caseStudy": null,
    "image": img9
  },
  {
    "name": "Chain of KO-mmand",
    "kind": "Web App",
    "summary": "Marketing website and platform entry point for the sports community product.",
    "stack": [
      "React"
    ],
    "url": "https://www.chainofko-mmand.com/",
    "caseStudy": null,
    "image": img10
  },
  {
    "name": "Oasis",
    "kind": "Web App",
    "summary": "Informational website serving as the digital gateway to a technology-enabled clean water monitoring and filtration control system.",
    "stack": [
      "React"
    ],
    "url": "https://www.oasiswatertechnologies.com/",
    "caseStudy": null,
    "image": img11
  },
  {
    "name": "Wave-Makers",
    "kind": "Mobile App",
    "summary": "Quiz and trivia app with rankings, achievements, event participation, and global leaderboard competition.",
    "stack": [
      "React Native",
      "Node.js",
      "MongoDB"
    ],
    "url": "https://apps.apple.com/us/app/wave-makers/id1664854004",
    "caseStudy": null,
    "image": img12
  },
  {
    "name": "Cabz App",
    "kind": "Mobile App",
    "summary": "Mobile companion for island taxi booking and transfers.",
    "stack": [
      "React Native",
      "Node.js"
    ],
    "url": "https://apps.apple.com/us/app/cabz-app/id6483860512",
    "caseStudy": null,
    "image": img13
  },
  {
    "name": "Chain of KO-mmand",
    "kind": "Mobile App",
    "summary": "Solo sports competitor platform for events, points, rewards, and community engagement.",
    "stack": [
      "React Native",
      "Node.js",
      "MongoDB"
    ],
    "url": "https://apps.apple.com/us/app/chain-of-ko-mmand/id6737414029",
    "caseStudy": null,
    "image": img14
  },
  {
    "name": "ACE",
    "kind": "Web App",
    "summary": "Promotional website and gateway to a complete football club management and match operations system",
    "stack": [
      "React"
    ],
    "url": "https://www.figma.com/design/Wkse8qb2Hme4LH7sbdXvba/ACE-web?node-id=0-1&p=f&t=c9zVWutCrEkPQNji-0",
    "caseStudy": null,
    "image": img15
  },
  {
    "name": "Gradia",
    "kind": "Web App",
    "summary": "Interface design and visual system for a student-centered digital platform.",
    "stack": [
      "React"
    ],
    "url": "https://www.figma.com/design/CQXUMvBconeVI7stD44nVg/Gradia-Web?node-id=1-14689&t=c9zVWutCrEkPQNji-0",
    "caseStudy": null,
    "image": img16
  },
  {
    "name": "n8n Workflow Automation",
    "kind": "AI Automation",
    "summary": "End-to-end business process automation using n8n: connecting CRMs, communication tools, and databases with zero-code glue and custom AI nodes.",
    "stack": [
      "n8n",
      "Node.js",
      "HubSpot",
      "Stripe",
      "OpenAI",
      "Airtable"
    ],
    "url": null,
    "caseStudy": "https://www.workflox.net/case-studies/n8n-workflow-automation-case-study",
    "image": img17
  },
  {
    "name": "Sneaker Authentication AI",
    "kind": "AI Product",
    "summary": "Computer vision system that authenticates sneakers with 97%+ accuracy. Deployed as a mobile scanning API for resale and authentication platforms.",
    "stack": [
      "Python",
      "TensorFlow",
      "FastAPI",
      "AWS Lambda",
      "React Native"
    ],
    "url": null,
    "caseStudy": "https://www.workflox.net/case-studies/sneaker-authentication-case-study",
    "image": img18
  },
  {
    "name": "FitBizZ – Fitness Platform AI",
    "kind": "AI Product",
    "summary": "AI-powered fitness coaching platform with personalised workout generation, progress tracking, and nutrition recommendations.",
    "stack": [
      "React Native",
      "Node.js",
      "OpenAI",
      "MongoDB",
      "Firebase"
    ],
    "url": null,
    "caseStudy": "https://www.workflox.net/case-studies/fitbizz-case-study",
    "image": img19
  },
  {
    "name": "Asemani – Smart Operations",
    "kind": "AI Product",
    "summary": "Intelligent operations platform for a GCC enterprise: automating procurement, approvals, and vendor communications with AI agents.",
    "stack": [
      "React",
      "Node.js",
      "LangChain",
      "PostgreSQL",
      "n8n",
      "OpenAI"
    ],
    "url": null,
    "caseStudy": "https://www.workflox.net/case-studies/asemani-case-study",
    "image": img20
  },
  {
    "name": "Mabwas – Property AI Agent",
    "kind": "AI Product",
    "summary": "AI-driven property management and tenant engagement platform: automating lease renewals, maintenance tickets, and landlord reporting.",
    "stack": [
      "Next.js",
      "Node.js",
      "OpenAI",
      "Twilio",
      "PostgreSQL",
      "Stripe"
    ],
    "url": null,
    "caseStudy": "https://www.workflox.net/case-studies/mabwas-case-study",
    "image": img21
  },
  {
    "name": "SHPD – AI Supply Chain",
    "kind": "AI Product",
    "summary": "Supply chain intelligence platform with demand forecasting, inventory optimisation, and automated supplier reorder flows.",
    "stack": [
      "Python",
      "FastAPI",
      "React",
      "PostgreSQL",
      "scikit-learn",
      "n8n"
    ],
    "url": null,
    "caseStudy": "https://www.workflox.net/case-studies/shpd-case-study",
    "image": img22
  }
];
